module.exports = __webpack_public_path__ + "img/replenishment_setting.d9b40571.png";